(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDeleteController',SmsLimitDeleteController);

    SmsLimitDeleteController.$inject = ['$uibModalInstance', 'entity', 'SmsLimit'];

    function SmsLimitDeleteController($uibModalInstance, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SmsLimit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
